<mwl-calendar-week-view
  [viewDate]="viewDate"
  [locale]="lang"
  [events]="events"
  [refresh]="refresh"
  [weekStartsOn]="weekStartOn"
  [weekendDays]="weekendDays"
  [excludeDays]="weekendDays"
  [dayStartHour]="dayStartOn?.getHours()"
  [dayStartMinute]="dayStartOn?.getMinutes()"
  [dayEndHour]="dayEndOn?.getHours()"
  [dayEndMinute]="dayEndOn?.getMinutes()"
  (eventClicked)="onEventClicked($event)"
  (eventTimesChanged)="onEventTimesChanged($event)">
</mwl-calendar-week-view>
